// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__gju2g","description":"PatientConsentPreview_description__1x41A"};